import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './News.css';

function News() {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Для форм - состояние
  const [showAddForm, setShowAddForm] = useState(false);
  const [editNewsId, setEditNewsId] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    date: '',
    image: null,
  });

  const API_URL = 'https://api.itosoba.ru/api/news';

  useEffect(() => {
    fetch(API_URL)
      .then(res => {
        if (!res.ok) {
          throw new Error('Ошибка при получении новостей');
        }
        return res.json();
      })
      .then(data => {
        setNewsList(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const refreshNews = () => {
    fetch(API_URL)
      .then(res => res.json())
      .then(data => setNewsList(data));
  };

  // Обработка изменений формы
  const handleInputChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({...formData, image: e.target.files[0] });
  };

  // Добавление новости
  const handleAddNews = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    data.append('date', formData.date || new Date().toISOString());
    if (formData.image) {
      data.append('image', formData.image);
    }

    fetch(API_URL, {
      method: 'POST',
      body: data,
    }).then(res => {
      if (!res.ok) throw new Error('Ошибка при добавлении новости');
      return res.json();
    }).then(() => {
      alert('Новость добавлена');
      setShowAddForm(false);
      setFormData({ title: '', content: '', date: '', image: null });
      refreshNews();
    }).catch(err => alert(err.message));
  };

  // Редактирование
  const handleEditClick = (newsItem) => {
    setEditNewsId(newsItem.id);
    setFormData({
      title: newsItem.title,
      content: newsItem.content,
      date: newsItem.date,
      image: null,
    });
  };

  const handleUpdateNews = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    data.append('date', formData.date);
    if (formData.image) {
      data.append('image', formData.image);
    }

    fetch(`${API_URL}/${editNewsId}`, {
      method: 'PUT',
      body: data,
    }).then(res => {
      if (!res.ok) throw new Error('Ошибка при редактировании новости');
      return res.json();
    }).then(() => {
      alert('Новость обновлена');
      setEditNewsId(null);
      setFormData({ title: '', content: '', date: '', image: null });
      refreshNews();
    }).catch(err => alert(err.message));
  };

  // Удаление новости
  const handleDelete = (newsId) => {
    if(!window.confirm('Вы действительно хотите удалить эту новость?')) return;

    fetch(`${API_URL}/${newsId}`, {
      method: 'DELETE',
    }).then(res => {
      if (!res.ok) throw new Error('Ошибка при удалении новости');
      alert('Новость удалена');
      refreshNews();
    }).catch(err => alert(err.message));
  };

  if (loading) return <p className="loading">Загрузка новостей...</p>;
  if (error) return <p className="error">Ошибка: {error}</p>;

  const latestNews = newsList.slice(0, 3);

  return (
    <div className="news-container">

      {/* Кнопка для добавления новости */}
      <button onClick={() => setShowAddForm(true)}>Добавить новость</button>

      {/* Форма добавления новости */}
      {showAddForm && (
        <form className="news-form" onSubmit={handleAddNews}>
          <h3>Добавить новость</h3>
          <input
            type="text"
            name="title"
            placeholder="Заголовок"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
          <textarea
            name="content"
            placeholder="Контент"
            value={formData.content}
            onChange={handleInputChange}
            required
          />
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
          />
          <input
            type="file"
            onChange={handleFileChange}
            accept="image/*"
          />
          <button type="submit">Добавить</button>
          <button type="button" onClick={() => setShowAddForm(false)}>Отмена</button>
        </form>
      )}

      {/* Обновление формы для редактирования (если выбрана редактируемая новость) */}
      {editNewsId && (
        <form className="news-form" onSubmit={handleUpdateNews}>
          <h3>Редактировать новость</h3>
          <input
            type="text"
            name="title"
            placeholder="Заголовок"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
          <textarea
            name="content"
            placeholder="Контент"
            value={formData.content}
            onChange={handleInputChange}
            required
          />
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
          />
          <input
            type="file"
            onChange={handleFileChange}
            accept="image/*"
          />
          <button type="submit">Обновить</button>
          <button type="button" onClick={() => setEditNewsId(null)}>Отмена</button>
        </form>
      )}

      {latestNews.length === 0 ? (
        <p className="no-news">Нет новостей</p>
      ) : (
        <div className="news-list">
          {latestNews.map((newsItem) => (
            <div key={newsItem.id} className="news-item">
              <Link to={`/news/${newsItem.id}`}>
                <h3 className="news-title">{newsItem.title}</h3>
                {newsItem.image_url && (
                  <img
                    src={`https://api.itosoba.ru${newsItem.image_url}`}
                    alt=""
                    className="news-image"
                  />
                )}
                <p className="news-content">{newsItem.content.substring(0, 200)}...</p>
                <span className="news-date">
                  {new Date(newsItem.date).toLocaleString()}
                </span>
              </Link>
              {/* Кнопки редактировать/удалить */}
              <div className="news-actions">
                <button onClick={() => handleEditClick(newsItem)}>Редактировать</button>
                <button onClick={() => handleDelete(newsItem.id)}>Удалить</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default News;